/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Next_SectionInputs */

const en_common_next_section = /** @type {(inputs: Common_Next_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next section`)
};

const es_common_next_section = /** @type {(inputs: Common_Next_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sección siguiente`)
};

/**
* | output |
* | --- |
* | "Next section" |
*
* @param {Common_Next_SectionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_next_section = /** @type {((inputs?: Common_Next_SectionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Next_SectionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_next_section(inputs)
	return en_common_next_section(inputs)
});